import { useState } from 'react';
import Header from './header';
import Footer from './footer';
import { Outlet } from 'react-router';
import { styled } from '@mui/material';
import SideBar from './sidebar';

let SIDE_NAV_WIDTH = 260;
const LayoutRoot = styled('div')(({ theme }) => ({
	display: 'flex',
	flex: '1 1 auto',
	maxWidth: '100%',
	backgroundColor: 'rgb(250, 250, 250)',
	transition: 'width 250ms ease',
	[theme.breakpoints.up('lg')]: {
		paddingLeft: SIDE_NAV_WIDTH,
	},
}));

const LayoutContainer = styled('div')({
	display: 'flex',
	flex: '1 1 auto',
	flexDirection: 'column',
	width: '100%',
});

export const AppLayout = () => {
	const [sideBar, setSideBar] = useState(true);
	SIDE_NAV_WIDTH = sideBar ? 260 : 0;

	return (
		<>
			<Header setSideBar={() => setSideBar(!sideBar)} sideBar={sideBar} />
			<SideBar open={sideBar} onClose={() => setSideBar(!sideBar)} />
			<LayoutRoot>
				<LayoutContainer>
					<Outlet />
				</LayoutContainer>
			</LayoutRoot>
			{/* <Footer /> */}
		</>
	);
};
